import React from "react";
import { Fichier } from "../../interfaces/fichier";

interface ActionGexboxProps {
  loading: boolean;
  fichiers: Fichier[];
  searchQuery: string;
  handleSearchChange: any;
  setFilterBar: (newvalue: boolean) => void;
  filterBar: boolean;
  setSelectedUser: any;
  setSelectedStatus: (newvalue: string) => void;
}
const ActionGexbox = ({
  loading,
  fichiers,
  searchQuery,
  handleSearchChange,
  setFilterBar,
  filterBar,
  setSelectedUser,
  setSelectedStatus,
}: ActionGexboxProps) => {
  return (
    <div className="lg:flex lg:items-center lg:justify-between sm:flex-row">
      <div className="mb-7">
        <div>
          <div className="flex items-center gap-x-3">
            <h2 className="  text-2xl font-medium text-gray-800 ">GexBox</h2>

            <span className="px-3 py-1 text-md font-semibold text-white bg-gexpertise-100 rounded-full ">
              {!loading &&
                fichiers?.filter(
                  (fichier) =>
                    fichier?.status_fichier.split(".").pop() === "A_TRAITER"
                ).length}{" "}
              fichier(s) à traiter
            </span>
            <span className="px-3 py-1 text-md font-semibold text-white bg-gexpertise-100 rounded-full ">
              {!loading &&
                fichiers?.filter(
                  (fichier) =>
                    fichier?.status_fichier.split(".").pop() === "EN_COURS"
                ).length}{" "}
              fichier(s) en cours
            </span>
            <span className="px-3 py-1 text-md font-semibold text-white bg-gexpertise-100 rounded-full ">
              {!loading &&
                fichiers?.filter(
                  (fichier) =>
                    fichier?.status_fichier.split(".").pop() ===
                    "ACTIF_EN_ATTENTE"
                ).length}{" "}
              fichier(s) en attente
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center mt-4 gap-x-3">
        <form className="flex items-center">
          <label htmlFor="simple-search" className="sr-only">
            Search
          </label>

          <div className="relative w-full">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                aria-hidden="true"
                className="w-5 h-5 text-gray-500 "
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              id="simple-search"
              className="block p-2 pl-10 text-md text-gray-900 border border-gray-300 rounded-lg w-80  focus:ring-gexpertise-200 focus:border-gexpertise-200 "
              placeholder="Recherche"
              value={searchQuery}
              onChange={handleSearchChange}
            ></input>
          </div>
        </form>
        <button
          onClick={() => {
            setFilterBar(!filterBar);
            setSelectedUser(null);
            setSelectedStatus("");
          }}
          className="flex items-center justify-center  px-5 py-2 text-md text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto "
        >
          <img src="/images/sort.png" />
          Filtres
        </button>
      </div>
    </div>
  );
};

export default ActionGexbox;
